export default {
  name: '文本'
}
